import { Mixins, Text, Box } from '@openfin/ui-library';
import React, { FC } from 'react';
import styled from 'styled-components';

import { WindowContext } from '../../contexts/WindowContext';
import { getDate } from '../../utils/Time';

interface Props {
  date: number;
}

export const NotificationTime: FC<Props> = (props) => {
  const { date } = props;
  const win = React.useContext(WindowContext);
  const [formattedDate, setFormattedDate] = React.useState<string>(getDate(date));

  React.useEffect(() => {
    const timer = win.setInterval(() => {
      setFormattedDate(getDate(date));
    }, 60 * 1000);

    return () => {
      win.clearInterval(timer);
    };
  }, []);

  return (
    <Container>
      <Text size="small" data-testid="time">
        {formattedDate}
      </Text>
    </Container>
  );
};

const Container = styled(Box)`
  top: 1px;
  ${Text} {
    white-space: nowrap;
    ${Mixins.textOverflow};
  }
`;
